import { motion, AnimatePresence } from 'framer-motion';
import { theme } from '../theme';

/**
 * Toast notification component
 * Displays temporary messages with smooth animations
 * @param {string} message - The message to display
 * @param {string} type - Type of toast (error, success, info)
 * @param {function} onClose - Callback when toast is closed
 */
export const Toast = ({ message, type = 'error', onClose }) => {
  const toastStyles = {
    error: {
      background: theme.colors.errorBg,
      border: `1px solid ${theme.colors.errorBorder}`,
      color: theme.colors.errorText,
      icon: '⚠️',
    },
    success: {
      background: theme.colors.successBg,
      border: `1px solid ${theme.colors.successBorder}`,
      color: theme.colors.successText,
      icon: '✓',
    },
    info: {
      background: theme.colors.infoBg,
      border: `1px solid ${theme.colors.infoBorder}`,
      color: theme.colors.infoText,
      icon: 'ℹ️',
    },
  };

  const style = toastStyles[type] || toastStyles.error;

  return (
    <AnimatePresence>
      {message && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.2 }}
          style={{
            position: 'fixed',
            bottom: '32px',
            right: '32px',
            padding: '16px 24px',
            background: style.background,
            border: style.border,
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
            maxWidth: '400px',
            minWidth: '280px',
            zIndex: theme.zIndex.toast,
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          <span style={{ fontSize: '20px' }}>
            {style.icon}
          </span>
          <p style={{
            margin: 0,
            fontSize: '14px',
            fontFamily: "'DM Sans', sans-serif",
            color: style.color,
            flex: 1,
            lineHeight: '1.5',
          }}>
            {message}
          </p>
          <button
            onClick={onClose}
            aria-label="Close notification"
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '20px',
              opacity: 0.5,
              padding: '0 4px',
              transition: 'opacity 0.2s ease',
            }}
            onMouseEnter={(e) => e.target.style.opacity = '1'}
            onMouseLeave={(e) => e.target.style.opacity = '0.5'}
          >
            ×
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
